import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaPlane,
  FaTaxi,
  FaHiking,
  FaHotel,
  FaUserShield,
  FaHeadset,
  FaRegEdit,
  FaWhatsapp,
} from "react-icons/fa";
import jasiro from "../../assets/places/jasiiro.jpg";
import bari from "../../assets/places/bari.jpg";
import kismaayo from "../../assets/places/kismaayo.jpg";
import mogadishu from "../../assets/places/mogadishu.jpg";
import icon from "../../assets/icons/usp/20.png";
import activity from "../../assets/icons/usp/activity.png";
import flight from "../../assets/icons/usp/flight.png";
import airport from "../../assets/icons/usp/airport.png";
import guide from "../../assets/icons/usp/guide.png";
import hotel from "../../assets/icons/usp/hotel.png";
import support from "../../assets/icons/usp/support.png";
import support2 from "../../assets/icons/usp/support2.png";
import support3 from "../../assets/icons/usp/support3.png";

const ServicesCard = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
  }, []);

  return (
    <div
      className="relative bg-cover bg-center dark:bg-black bg-white dark:text-white text-black py-16 px-8"
      style={{
        backgroundImage: "url('/path-to-your-background-image.jpg')", // Replace with your background image path
      }}
    >
      <div className="relative md:max-w-6xl mx-auto text-center">
        <h1 data-aos="fade-up" className="text-4xl md:text-5xl font-bold mb-12">
          We'll handle your trip for you
        </h1>

        <div
          data-aos="fade-up"
          className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8"
        >
          {/* Flight Booking */}
          <div className="service-card p-2 flex flex-col md:flex-row items-center gap-4">
            <img
              src={flight}
              alt="Flight Booking"
              className="md:w-32 md:h-32 bg-indigo-500 dark:bg-transparent w-48 rounded-3xl object-cover md:rounded-full"
            />
            <div className="text-justify">
              <h2 className="text-2xl font-bold mb-2 flex items-center">
                <FaPlane className="mr-2 text-indigo-500 icon-vibrate" /> Flight
                Booking
              </h2>
              <p className="text-md">
                Discover seamless and affordable flight bookings with us.
                Whether you’re planning a business trip or a vacation, we ensure
                a smooth, hassle-free experience with trusted airline partners.
              </p>
            </div>
          </div>

          {/* Airport Transfers */}
          <div className="service-card p-2 flex flex-col md:flex-row items-center gap-4">
            <img
              src={airport}
              alt="Airport Transfers"
              className="md:w-32 md:h-32 w-48 bg-indigo-500 dark:bg-transparent rounded-3xl object-cover md:rounded-full"
            />
            <div className="text-justify">
              <h2 className="text-2xl font-bold mb-2 flex items-center">
                <FaTaxi className="mr-2 text-indigo-500" /> Airport Transfers
              </h2>
              <p className="text-md">
                Enjoy peace of mind with our reliable airport transfer services.
                Arrive or depart with comfort and ease, knowing professional
                drivers are there for you.
              </p>
            </div>
          </div>

          {/* Tours & Activities */}
          <div className="service-card p-2 flex flex-col md:flex-row items-center gap-4">
            <img
              src={activity}
              alt="Tours & Activities"
              className="md:w-32 md:h-32 w-48 bg-indigo-500 dark:bg-transparent rounded-3xl object-cover md:rounded-full"
            />
            <div className="text-justify">
              <h2 className="text-2xl font-bold mb-2 flex items-center">
                <FaHiking className="mr-2 text-indigo-500" /> Tours & Activities
              </h2>
              <p className="text-md">
                Unleash the explorer in you with handpicked tours and
                activities, tailored to give you unforgettable experiences.
              </p>
            </div>
          </div>

          {/* Hotel Bookings */}
          <div className="service-card p-2 flex flex-col md:flex-row items-center gap-4">
            <img
              src={hotel}
              alt="Hotel Bookings"
              className="md:w-32 md:h-32 w-48 bg-indigo-500 dark:bg-transparent rounded-3xl object-cover md:rounded-full"
            />
            <div className="text-justify">
              <h2 className="text-2xl font-bold mb-2 flex items-center">
                <FaHotel className="mr-2 text-indigo-500" /> Hotel Bookings
              </h2>
              <p className="text-md">
                Stay at the best hotels that suit your budget and preferences.
                Verified accommodations ensure a secure and relaxing stay.
              </p>
            </div>
          </div>

          {/* Tour Guide */}
          <div className="service-card p-2 flex flex-col md:flex-row items-center gap-4">
            <img
              src={guide}
              alt="Hotel Bookings"
              className="md:w-32 md:h-32 w-48 bg-indigo-500 dark:bg-transparent rounded-3xl object-cover md:rounded-full"
            />
            <div className="text-justify">
              <h2 className="text-2xl font-bold mb-2 flex items-center">
                <FaUserShield className="mr-2 text-indigo-500" /> Tour Guide
              </h2>
              <p className="text-md">
                Your main point of contact from the start to the end of your
                trip, offering 24/7 support. The tour guide will address all
                your questions and provide insights to help you better
                understand the destination.
              </p>
            </div>
          </div>

          {/* WhatsApp Travel Support */}
          <div className="service-card p-2 flex flex-col md:flex-row items-center gap-4">
            <img
              src={support}
              alt="Hotel Bookings"
              className="md:w-32 md:h-32 w-48 bg-indigo-500 dark:bg-transparent rounded-3xl object-cover md:rounded-full"
            />
            <div className="text-justify">
              <h2 className="text-2xl font-bold mb-2 flex items-center">
                <FaWhatsapp className="mr-2 text-indigo-500" /> WhatsApp Support
              </h2>
              <p className="text-md">
                Stay connected throughout your trip with 24/7 WhatsApp support.
                Get quick responses to your questions and enjoy seamless
                assistance from start to finish.
              </p>
            </div>
          </div>

          {/* Around-the-Clock Customer Support */}
          <div className="service-card p-2 flex flex-col md:flex-row items-center gap-4">
            <img
              src={support2}
              alt="Hotel Bookings"
              className="md:w-32 md:h-32 w-48 bg-indigo-500 dark:bg-transparent rounded-3xl object-cover md:rounded-full"
            />
            <div className="text-justify">
              <h2 className="text-2xl font-bold mb-2 flex items-center">
                <FaHeadset className="mr-2 text-indigo-500" /> 24/7 Customer
                Support
              </h2>
              <p className="text-md">
                Available 24/7 to assist you with any questions or concerns,
                ensuring you receive help whenever you need it.
              </p>
            </div>
          </div>

          {/* Customize Your Trip */}
          <div className="service-card p-2 flex flex-col md:flex-row items-center gap-4">
            <img
              src={support3}
              alt="Hotel Bookings"
              className="md:w-32 md:h-32 w-48 bg-indigo-500 dark:bg-transparent rounded-3xl object-cover md:rounded-full"
            />
            <div className="text-justify">
              <h2 className="text-2xl font-bold mb-2 flex items-center">
                <FaRegEdit className="mr-2 text-indigo-500" /> Customize Your
                Trip
              </h2>
              <p className="text-md">
                Tailor your journey to fit your unique preferences. From
                destinations to experiences, we create a personalized itinerary
                that ensures your trip is exactly what you want, making every
                moment unforgettable.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesCard;
